export const SEARCH_FORM_POST = '/ECMv6/api/ext/forms/search';
export const CREATE_FORM_POST = '/ECMv6/api/ext/forms';
export const FORMS_GET = '/ECMv6/api/ext/forms';
export const LIVE_FORMS_GET = '/ECMv6/api/ext/forms/submit';
/** SavOQ templates list: GET; template definition: GET `${SAV_OQ_OBJECTS_GET}?objectKey=` */
export const SAV_OQ_OBJECTS_GET = `${FORMS_GET}/datastore/templates`;
export const BRANDING_UPLOAD_POST = '/ECMv6/api/ext/forms/branding/upload';
export const SUBMIT_FROM_POST = '/ECMv6/api/ext/forms/submit';
export const SQLPROVIDER_DATA_POST = '/ECMv6/api/ext/forms/submit/data';
export const DATAPROVIDER_PREVIEW_POST = '/ECMv6/api/ext/forms/preview/data';
export const ACTIONS_LIST_GET = '/ECMv6/api/ext/action/search';
export const CREDENTIALS_SEARCH_POST = '/ECMv6/api/ext/credentials/search';
export const USER_ACTION_POST = '/ECMv6/api/ext/action/details';
export const AI_CHAT_POST = '/ECMv6/api/ext/forms/ai/chat';
export const GENERATE_FORM_FROM_DA = '/ECMv6/api/ext/forms/dynamicattributes';

export const DA_REQUEST_TYPE = {
  USERS: 'USERS',
  SERVICE_ACCOUNT: 'SERVICE_ACCOUNT',
  ACCOUNT: 'ACCOUNT',
} as const;

export const DA_ACTION = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
} as const;
export const GENERATE_FORM_FROM_DA_SERVICE_ACCOUNT = `${GENERATE_FORM_FROM_DA}/serviceaccount?includeDefaultValues=true`;
export const GENERATE_FORM_FROM_DA_ACCOUNT = `${GENERATE_FORM_FROM_DA}/account?includeDefaultValues=true`;
export const GENERATE_FORM_FROM_DA_USER_CREATE = `${GENERATE_FORM_FROM_DA}/user/create?includeDefaultValues=true`;
export const GENERATE_FORM_FROM_DA_USER_UPDATE = `${GENERATE_FORM_FROM_DA}/user/update?includeDefaultValues=true`;
export const FORMS_GET_STATUSES = `${SEARCH_FORM_POST}/statuses`;
export const FORM_GET_METADATA = `${SEARCH_FORM_POST}/meta`;
export const FORMS_GET_CREATORS = `${SEARCH_FORM_POST}/meta`;
export const FORMS_GET_UPDATERS = `${SEARCH_FORM_POST}/meta`;
export const CONFIG_SEARCH_POST = '/ECMv6/api/ext/ecmconfig/search';

// Form Action APIs
export const FORM_EXPORT_POST = '/ECMv6/api/ext/forms/export';
export const FORM_IMPORT_POST = '/ECMv6/api/ext/forms/import';
export const FORM_DUPLICATE_POST = '/ECMv6/api/ext/forms/clone';
export const FORM_VALIDATE_POST = '/ECMv6/api/ext/forms/validate';
export const FORM_STATUS_TRANSITION_PUT = '/ECMv6/api/ext/forms';
export const GET_ENTITY_DETAILS_POST = '/ECMv6/api/ext/forms/submit/data/load';
export const PREVIEW_GET_ENTITY_DETAILS_POST =
  '/ECMv6/api/ext/forms/preview/data/load';
export const ORCHESTRATION_INVOKE_METHOD_API =
  '/ECMv6/api/o12/orchestration/input-parameters/:param';

// Form Access Management APIs
export const FORM_ACCESS_BASE = '/ECMv6/api/ext/forms/access';
export const FORM_ENTITIES_SEARCH_POST = '/ECMv6/api/ext/forms/entities/search';

// Public Form APIs (unauthenticated)
export const PUBLIC_FORMS_GET = '/ECMv6/api/ext/public/forms/submit';
export const PUBLIC_FORM_SUBMIT = '/ECMv6/api/ext/public/forms/submit';

// Duplicate Check Validation APIs
export const FORM_VALIDATE_DUPLICATE_POST =
  '/ECMv6/api/ext/forms/submit/data/validate';
export const PREVIEW_FORM_VALIDATE_DUPLICATE_POST =
  '/ECMv6/api/ext/forms/preview/data/validate';
export const PUBLIC_FORM_VALIDATE_DUPLICATE_POST =
  '/ECMv6/api/ext/public/forms/data/validate';

// Form Configuration API
export const FORM_CONFIG_GET = '/ECMv6/api/ext/forms/config';
